import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Wrapper from "../../components/Wrapper";

import { getSellers } from "./api";

export default function Sellers() {
  const [data, setdata] = useState([]);
  useEffect(() => {
    const getData = async () => {
      const response = await getSellers();
      setdata(response);
    };
    getData();
  }, []);

  return (
    <Wrapper>
      {data &&
        data.map((d) => (
          <Link
            to={{
              pathname: `/sellers/${d.id}`,
              state: d,
            }}
            key={d.id}
            className="card"
          >
            <img src={d.logo} alt="" />
            <div>
              <div>
              <strong>Name: </strong>
              {d.name}
            </div>
            <div>
              <strong>Description: </strong>
              {d.description.substring(0, 100) + "..."}
            </div>
            </div>
            
          </Link>
        ))}
    </Wrapper>
  );
}
